import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../../../../../api/admin";

const useGetClockOnlineLogs = (
  clockId: string,
  dateLimit: string,
  enabled: boolean,
) => {
  const query = useQuery({
    queryKey: ["clock-online-logs", clockId, dateLimit],
    queryFn: () => adminApiClient.getClockOnlineLogs(clockId, dateLimit),
    enabled: !!clockId && enabled,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return query;
};

export default useGetClockOnlineLogs;
